import { useMemo } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import { useLocalization } from 'localization';
import { EditIcon } from 'components/v2/icons/EditIcon';
import MinusIcon from 'components/v2/icons/MinusIcon';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { SocialMedia } from 'api/branches/dto';

export const useBranchSetting = () => {
  const { t, f } = useLocalization();
  const { toggleModal } = MODALS_STORE.branch();

  const connectedAccountColumns = useMemo(() => {
    return [
      {
        headerName: t('accountSetting.platform'),
        field: 'platform',
        width: 200,
        sortable: false,
      },
      {
        headerName: t('common.terms.lastUpdated'),
        field: 'updatedAt',
        width: 250,
        sortable: false,
        valueGetter: (value: SocialMedia['updatedBy']) => (value ? f(new Date(value), { date: 'short' }) : '-'),
      },
      {
        headerName: t('common.terms.url'),
        field: 'url',
        width: 200,
        minWidth: 300,
        flex: 1,
        sortable: false,
      },

      {
        headerName: t('common.terms.actions'),
        field: 'id',
        key: 'actions',
        width: 150,
        sortable: false,
        renderCell: (params: GridRenderCellParams<SocialMedia, SocialMedia['id']>) => {
          return (
            <Stack direction="row" gap={2} alignItems="center" justifyContent="center" height={'100%'}>
              <Tooltip title={t('accountSetting.editAccount')}>
                <IconButton
                  aria-label="view-case"
                  sx={{ border: '1px solid' }}
                  size="medium"
                  onClick={() =>
                    toggleModal(MODAL_ID.ADD_EDIT_SOCIAL_MEDIA_ACCOUNT, {
                      isEdit: true,
                      socialMedia: {
                        platform: params.row.platform,
                        url: params.row.url,
                        id: params.row.id,
                      },
                    })
                  }
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t('accountSetting.deleteAccount')}>
                <IconButton
                  aria-label="get-material"
                  sx={{ border: '1px solid' }}
                  size="medium"
                  onClick={() =>
                    toggleModal(MODAL_ID.DELETE_SOCIAL_MEDIA_ACCOUNT, {
                      socialMedia: {
                        id: params.row.id,
                      },
                    })
                  }
                >
                  <MinusIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        },
      },
    ];
  }, [t, f]);

  return {
    ui: {
      table: { columns: connectedAccountColumns },
    },
  };
};
